module.exports = __webpack_public_path__ + "img/receiptsign.818bcd30.png";